import { MAX_CANVAS_DIM } from '../app/config.ts';

/**
 * Returns a scaled DPR based on screen size to reduce GPU load on
 * smaller / less powerful devices. The CSS canvas still fills the
 * viewport — the browser upscales the lower-res buffer automatically.
 */
function getEffectiveDpr(): number {
  const dpr = window.devicePixelRatio || 1;
  const cssWidth = window.innerWidth;

  // Phone-sized screens: render at 1x regardless of device DPR
  if (cssWidth <= 600) return Math.min(dpr, 1.0);
  // Tablet / small laptop: cap at 1.5x
  if (cssWidth <= 1200) return Math.min(dpr, 1.5);
  // Large screens: cap at 2x (even 3x retina doesn't need full res for a shader)
  return Math.min(dpr, 2.0);
}

export function setupResize(canvas: HTMLCanvasElement, _device: GPUDevice) {
  let currentWidth = 0;
  let currentHeight = 0;

  function updateIfNeeded() {
    const dpr = getEffectiveDpr();
    const displayW = Math.min(Math.floor(canvas.clientWidth * dpr), MAX_CANVAS_DIM);
    const displayH = Math.min(Math.floor(canvas.clientHeight * dpr), MAX_CANVAS_DIM);

    if (canvas.width !== displayW || canvas.height !== displayH) {
      canvas.width = displayW;
      canvas.height = displayH;
      currentWidth = displayW;
      currentHeight = displayH;
    }
  }

  // Initial sizing
  updateIfNeeded();

  return {
    updateIfNeeded,
    get width() { return currentWidth; },
    get height() { return currentHeight; },
  };
}
